module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA8BAMAAAAnEK9/AAAAHlBMVEUAAAD///////////////////////////////////8kfJuVAAAACXRSTlMAfx8gn98Qb48+C6IrAAAAPUlEQVQ4y2MYBaOAGGCMAgww5CNnIoNJVJcvFEQGYgzDDdA6/FpckIEbw3ADaOmD7uGrhAIUGEbBKCACAACbdFotpSLUeQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/nav_img.png
// module id = KOZR
// module chunks = 12